import React from "react";
import './about-page.style.css';
const AboutPage = () =>
(
    <div className="about-container">
        <p>This website was created by Anas Chahid Using React.js and New York Time API</p>
        <p>Visit my personal portfolio for more projects <a href="https://anaschahid.netlify.app/" rel="noreferrer" target="_blank">Website</a></p>       
    </div>
)

export default AboutPage;